export const MSAL_EXP_CLAIM = 'exp';
export const MSAL_DEFAULT_ENVIRONMENT = 'login.microsoftonline.com';
export const MSAL_DEVICE_ID_TTL_MS = 60 * 1000;

export type MsalAuthTokenOptions = {
  scopes?: string[];
  forceRefresh?: boolean;
  allowInteraction?: boolean;
  returnUrl?: string;
};

export type MsalSilentAuthOptions = {
  scopes?: string[];
  loginHint?: string | null;
};
